import { atom } from 'jotai';
export const $ServerContext = atom({});
